import { apiClient } from '@/lib/api/client';
export const notificationsApi = {
    async getNotifications(query) {
        const { data } = await apiClient.get('/api/v1/notifications', {
            params: query,
        });
        return data;
    },
    async getUnreadCount() {
        const { data } = await apiClient.get('/api/v1/notifications/unread-count');
        return data;
    },
    async markAsRead(id) {
        await apiClient.patch(`/api/v1/notifications/${id}/read`);
    },
    async markAllAsRead() {
        await apiClient.patch('/api/v1/notifications/read-all');
    },
};
//# sourceMappingURL=notifications.js.map